"use client"

interface SectionTabsProps {
  sections: any[]
  activeSection: string
  setActiveSection: (section: string) => void
}

export default function SectionTabs({ sections, activeSection, setActiveSection }: SectionTabsProps) {
  return (
    <div className="flex gap-2 mb-6 overflow-x-auto pb-2">
      {sections.map((section) => (
        <button
          key={section.key}
          onClick={() => setActiveSection(section.key)}
          className={`px-4 py-2 rounded-lg whitespace-nowrap ${
            activeSection === section.key ? "bg-blue-600 text-white" : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          {section.title}
        </button>
      ))}
    </div>
  )
}
